import { useEffect } from 'react';
import { useStoreValue, storeSet } from '../store';

const useCacheProjectAudio = (projectId) => {
    const cueSheet = useStoreValue('cueSheet');

    useEffect(() => {
        if (projectId && cueSheet && cueSheet.length > 0) {
            storeSet('cacheProjectAudio', projectId);
        }
    }, [projectId, cueSheet]);
};

export default useCacheProjectAudio;
